import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";

// const env = import.meta.env;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Cyber Security Risk Assessment List
export const fetchCyberSecurityRiskAssessmentList = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/${companyProfileID}/Details`
    );

    // console.log("fetchCyberSecurityRiskAssessmentList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Cyber Security Risk Assessment by Id
export const fetchCyberSecurityRiskAssessmentById = async (
  assessmentId: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Id/${assessmentId}/Details`
    );

    // console.log("fetchCyberSecurityRiskAssessmentById res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Cyber Security Risk Assessment List
export const createCyberSecurityRiskAssessment = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity`,
      payload
    );

    // console.log("createCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Cyber Security Risk Assessment List
export const updateCyberSecurityRiskAssessment = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity`,
      payload
    );

    // console.log("updateCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Cyber Security Risk Assessment List
export const deleteCyberSecurityRiskAssessment = async (
  assessmentId: any,
  userId: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Delete?id=${assessmentId}&updatedby=${userId}`
    );

    // console.log("deleteCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Multiple Cyber Security Risk Assessment List
export const deleteMultipleCyberSecurityRiskAssessment = async (
  userId: number,
  payload: any
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Multiple/Delete?updatedby=${userId}`,
      payload
    );

    // console.log("deleteMultipleCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Import Cyber Security Risk Assessment
export const importCyberSecurityRiskAssessment = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Import/Details?companyProfileID=${companyProfileID}`
    );

    // console.log("importCyberSecurityRiskAssessment res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Import Cyber Security Risk Assessment List
export const createImportCyberSecurityRiskAssessment = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Import/Create`,
      payload
    );

    // console.log("createCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Cyber Security Risk Assessment
export const downloadCyberSecurityRiskAssessment = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/${companyProfileID}/Dwonload`
    );

    // console.log("downloadCyberSecurityRiskAssessment res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Cyber Security Risk Assessment List
export const fetchThreatSourceList = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/ThreatSource/${companyProfileID}/Details`
    );

    // console.log("FetchThreatSourceList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Cyber Security Risk Assessment List
export const fetchVulnerabilityList = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Vulnerability/${companyProfileID}/Details`
    );

    // console.log("FetchThreatSourceList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Control List
export const fetchControlList = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Controls/${companyProfileID}/Details`
    );

    // console.log("fetchControlList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Dropdown List
export const fetchDropdownList = async (companyProfileID: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/All/Dropdown/${companyProfileID}/Details`
    );

    // console.log("fetchDropdownList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Risk Assessment List
export const fetchSupplyChainRiskAssessmentList = async (
  companyProfileId: number,
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain/details?CompanyProfileID=${companyProfileId}`
    );

    // console.log("fetchCyberSecurityRiskAssessmentList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create supply chain Risk Assessment List
export const createSupplyChainRiskAssessment = async (payload: any) => {
  // console.log("createSupplyChainRiskAssessment payload", payload);
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain`,
      payload
    );

    // console.log("createSupplyChainRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Multiple supply chain Risk Assessment List
export const createMultipleSupplyChainRiskAssessment = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain/list`,
      payload
    );
    // console.log("createMultipleSupplyChainRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Supply Chain Risk Assessment List
export const updateSupplyChainRiskAssessment = async (payload: any) => {
  // console.log("updateSupplyChainRiskAssessment payload", payload);

  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain`,
      payload
    );

    // console.log("updateSupplyChainRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Supply Chain Risk Assessment List
export const deleteSupplyChainRiskAssessment = async (
  assessmentId: any,
  userId: number
) => {
  try {
    const res = await axios.delete(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain?userid=${userId}&riskAssessmentId=${assessmentId}`
    );

    // console.log("deleteCyberSecurityRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Multiple Supply Chain Risk Assessment List
export const deleteMultipleSupplyChainRiskAssessment = async (
  userId: number,
  payload: any
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain/Multiple/Delete?updatedby=${userId}`,
      payload
    );

    // console.log("deleteMultipleSupplyChainRiskAssessment res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Templtes
export const downloadTemplates = async () => {
  // console.log("downloadTemplates");
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/SupplyChain/Download/Template`,
      {},
      {
        responseType: "arraybuffer",
        headers: {
          Accept: "application/octet-stream",
        },
      }
    );

    return res.data; // Return binary data
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
